import type { IButtonStyles } from '@fluentui/react';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppSplitButton, constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import ClipboardPaste from 'owa-fluent-icons-svg/lib/icons/ClipboardPasteRegular';
import loc from 'owa-localize';
import { FormatControlId } from 'owa-ribbon-ids';
import { getCopyControl } from './copy';
import { getCutControl } from './cut';
import { pasteText } from './formatControlStrings.locstring.json';
import { pasteOperation } from './paste';
import { isFeatureEnabled } from 'owa-feature-flags';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';

export const getPasteCutCopyControl = computedFn(
    (
        editorViewState: EditorViewState,
        styles: IButtonStyles | undefined,
        tabId: number | undefined
    ): RibbonControlProps => {
        return createAppSplitButton(
            getComposeRibbonId(FormatControlId.PasteCutCopy, editorViewState),
            loc(pasteText),
            {
                sections: [
                    {
                        controls: [
                            getCutControl(
                                editorViewState,
                                styles,
                                tabId,
                                FormatControlId.PasteCutCopy
                            ),
                            getCopyControl(
                                editorViewState,
                                styles,
                                tabId,
                                FormatControlId.PasteCutCopy
                            ),
                        ],
                    },
                ],
            },
            async () => {
                await pasteOperation(editorViewState.editorId);
            },
            tabId && isFeatureEnabled('mon-ribbon-keytips')
                ? constructKeytip(
                      [getKeytipString(tabId)],
                      getKeytipString(FormatControlId.PasteCutCopy),
                      true
                  )
                : undefined,
            ClipboardPaste,
            undefined /* iconColor */,
            styles
        );
    }
);
